<template>
  <div class="Nosotros">
    <div class="banner-bg"></div>

    <div class="content-box">
      <div class="content">
        <img class="img41" src="@/assets/home/img42.png" />

        <div style="position: relative; z-index: 9">
          <div class="pagetitle">Términos de Uso</div>
          <div class="description margin-b20">
            Estos Términos y Condiciones de Uso (en adelante, los "Términos")
            son elaborados por Zoriona, S.A. de C.V., SOFOM, E.N.R. (en
            adelante, la "Compañía") y son aplicables a todos aquellos usuarios
            que accedan y utilicen el sitio web oficial
            https://www.zorionasofom.com/ (en adelante, el "Sitio Web") y la
            aplicación móvil Lumi: Créditos y préstamos (en adelante, "Lumi").
            Estos Términos regulan integralmente la operación de la plataforma y
            las conductas de los usuarios, definiendo claramente los derechos y
            obligaciones de ambas partes.
          </div>
          <div class="paragraph">I. Definición de Términos</div>
          <div class="description">
            Los siguientes términos tienen un significado específico en estos
            Términos, independientemente de si aparecen en mayúsculas, en
            negrita o entre comillas, y las formas singular y plural, así como
            masculino y femenino, se interpretan de manera intercambiable:
          </div>
          <div class="tag">
            <span class="font-weight">1. Lumi:</span>
            Se refiere a la aplicación móvil desarrollada por Zoriona. Los
            usuarios pueden acceder a servicios de crédito y relacionados a
            través de dispositivos móviles. También incluye cualquier otro
            producto similar desarrollado por la Compañía en el futuro.
          </div>
          <div class="tag">
            <span class="font-weight">2. Beneficiario: </span>
            Es la persona o entidad que disfruta realmente de los derechos
            derivados del servicio y ejerce el derecho de disposición sobre los
            bienes o servicios.
          </div>
          <div class="tag">
            <span class="font-weight">3. Usuario Físico: </span>
            Son aquellos clientes que se registran y utilizan los servicios de
            la Compañía en calidad de personas naturales.
          </div>
          <div class="tag">
            <span class="font-weight">4.Usuario Moral: </span>
            Son las entidades legales constituídas conforme a las leyes
            mexicanas que establecen un contrato de servicio con la Compañía.
          </div>
          <div class="tag">
            <span class="font-weight">5. Día Hábil Bancario: </span>
            Según las disposiciones de la Comisión Nacional Bancaria y de
            Valores (CNBV), es el día en que las instituciones financieras
            realizan sus operaciones normalmente.
          </div>
          <div class="tag">
            <span class="font-weight">6. LGTOC:</span>
            Ley General de Títulos y Operaciones de Crédito, que es la normativa
            principal que regula las operaciones de la Compañía.
          </div>
          <div class="tag">
            <span class="font-weight">7. Sitio Web: </span>
            El sitio web con el dominio https://www.zorionasofom.com/, donde se
            presentan los términos de servicio, información de productos,
            tarifas y contactos.
          </div>
          <div class="tag">
            <span class="font-weight">8. Plataforma:</span>
            Incluye Lumi y cualquier otra plataforma digital que la Compañía
            lance en el futuro.
          </div>
          <div class="tag">
            <span class="font-weight">9. Servicios: </span>
            Son las soluciones de crédito y servicios complementarios que la
            Compañía ofrece a través de aplicaciones móviles, sitios web u otros
            canales electrónicos a aquellos usuarios que cumplan con los
            estándares de evaluación crediticia.
          </div>
          <div class="tag">
            <span class="font-weight">10. Sistema SPEI: </span>
            Sistema de Pagos Electrónicos Interbancarios de México, que se
            utiliza para la entrega de préstamos y el pago de cuotas.
          </div>
          <div class="tag margin-b20">
            <span class="font-weight">11. Visitante:</span>
            Cualquier persona o entidad que navegue o utilice las funciones
            básicas de la plataforma sin registrarse como cliente de la
            Compañía.
          </div>

          <div class="paragraph">II. Validez del Acuerdo Electrónico</div>
          <div class="description margin-b20">
            Al registrarse, iniciar sesión en Lumi o aceptar los servicios, los
            usuarios confirman estos Términos a través de la autenticación
            electrónica (por ejemplo, código de verificación por mensaje de
            texto). Este acto es equivalente a una firma electrónica reconocida
            por el Código de Comercio y tiene la misma fuerza legal que una
            firma manuscrita. Los usuarios declaran haber leído y aceptado
            voluntariamente los contenidos de estos Términos.
          </div>

          <div class="paragraph">III. Uso del Servicio y Reglas de Acceso</div>
          <div class="paragraph">A. Compromiso del Usuario</div>
          <div class="description">
            Sólo pueden utilizar los servicios de la plataforma aquellos
            usuarios mayores de 18 años y con capacidad civil plena. Los
            usuarios deben garantizar que la información de registro sea
            verdadera y válida, utilizar los servicios en su propio nombre y
            asumir toda la responsabilidad derivada de su uso.
          </div>
          <div class="paragraph">B. Conductas Prohibidas</div>
          <div class="description margin-b20">
            Se prohíbe utilizar la plataforma para cualquier actividad ilícita,
            fraudulenta o que viole la moral y los usos públicos, así como el
            uso de funciones fuera del alcance del servicio contratado. Si un
            usuario no acepta estos Términos, debe cesar inmediatamente el
            acceso a la plataforma.
          </div>

          <div class="paragraph">IV. Normas de Operación de la Plataforma</div>
          <div class="description">
            En cuanto a los horarios de operación de los servicios, los
            servicios de crédito se brindan las 24 horas del día, los 7 días de
            la semana, sin interrupción; y el servicio de soporte al cliente
            estará disponible de lunes a viernes, de 09:00 a 18:00 horas.
          </div>
          <div class="description margin-b20">
            Después de descargar la App Lumi, los usuarios deben completar la
            autenticación real (presentando documentos de identidad, información
            de cuenta bancaria, etc.) y pasar una evaluación crediticia. Una vez
            aprobados, recibirán una cuenta exclusiva y un límite de crédito.
          </div>

          <div class="paragraph">
            V. Declaración de Derechos y Obligaciones del Usuario
          </div>
          <div class="paragraph">A. Aplicabilidad del Servicio</div>
          <div class="description">
            Los servicios de la Compañía se ofrecen únicamente a aquellos
            usuarios que cumplan con los estándares de evaluación crediticia,
            incluyendo, entre otros, edad, estabilidad de ingresos y historial
            crediticio.
          </div>
          <div class="paragraph">
            B. Mecanismo de Confirmación de Transacciones
          </div>
          <div class="description">
            Las solicitudes de préstamo presentadas por los usuarios entrarán en
            vigor una vez confirmadas por el sistema de la Compañía. El tiempo
            de procesamiento real puede variar debido al flujo de evaluación.
          </div>
          <div class="paragraph">C. Información de Riesgos</div>
          <div class="description">
            Los usuarios reconocen que las transacciones en línea presentan
            riesgos técnicos (por ejemplo, filtración de datos, ataques
            cibernéticos). La Compañía sólo se hace responsable de las pérdidas
            causadas por su propia culpa.
          </div>
          <div class="paragraph">
            D. Responsabilidad en la Gestión de Contraseñas
          </div>
          <div class="description margin-b20">
            Los usuarios deben guardar con seguridad la contraseña de su cuenta.
            Cualquier pérdida causada por la filtración, robo o error de
            operación de la contraseña será asumida por el usuario. Si detectan
            cualquier anomalía en su cuenta, deben contactar inmediatamente con
            el servicio al cliente a través del correo electrónico
            servicio@zorionasofom.com o al teléfono +52 5573628956.
          </div>

          <div class="paragraph">VI. Información de Identificación</div>
          <div class="description">
            Para brindar los servicios de Lumi, Zoriona, S.A. de C.V., SOFOM,
            E.N.R. recopilará la siguiente información:
          </div>
          <div class="description">
            1. Apellidos paterno y materno y nombre completo (sin abreviaturas).
          </div>
          <div class="description">2. Género</div>
          <div class="description">3. Fecha de nacimiento.</div>
          <div class="description">4. Entidad federativa de nacimiento.</div>
          <div class="description">5. País de nacimiento.</div>
          <div class="description">6. Nacionalidad.</div>
          <div class="description">7. Clave de elector (si corresponde).</div>
          <div class="description">
            8. Domicilio, incluyendo nombre de la calle, número exterior e
            interior (si corresponde), colonia, delegación o municipio, ciudad,
            entidad federativa, código postal y país.
          </div>
          <div class="description">
            9. Si el usuario reside en el extranjero pero tiene un domicilio en
            México para recibir correspondencia, debe proporcionar detalles de
            dicho domicilio (con los mismos elementos que se describen
            anteriormente), así como su ocupación, profesión o giro de negocio.
          </div>
          <div class="description">
            10. Clave Única de Registro de Población (CURP).
          </div>
          <div class="description">11. Firma manuscrita digitalizada.</div>
          <div class="description">
            12. Número de teléfono de contacto válido.
          </div>
          <div class="description">13. Dirección de correo electrónico.</div>
          <div class="description">
            14. Número de cuenta bancaria y Clave Bancaria Estándarizada (CLABE)
            en una institución financiera autorizada para recibir depósitos, con
            el nombre del titular coincidiendo con el nombre del usuario.
          </div>
          <div class="description">
            15. Usuarios naturales deben declarar que utilizan los servicios en
            su propio nombre.
          </div>
          <div class="description margin-b20">
            16. Versión digitalizada de un documento oficial de identificación
            válido.
          </div>
          <div class="description margin-b20">
            Los usuarios tienen la obligación de proporcionar información
            verdadera y documentos válidos, y deben operar siempre en su propio
            nombre.
          </div>

          <div class="paragraph">
            VII. Responsabilidad de la Compañía y Cláusulas de Exención de
            Responsabilidad
          </div>
          <div class="description">
            1. Los usuarios deben guardar con seguridad sus firmas, claves de
            acceso y demás información de acceso a la cuenta. La Compañía no se
            hace responsable de cualquier filtración de información y las
            consecuencias derivadas (incluyendo, entre otras, pérdidas
            financieras y filtración de datos) causadas por la negligencia o el
            mal manejo por parte del usuario.
          </div>
          <div class="description">
            2. La información enviada o transmitida por los usuarios después de
            la autenticación será considerada válida siempre y cuando sea
            conforme a la legislación aplicable. Se asume que dicha información
            es enviada a través de dispositivos seguros y es recibida íntegra y
            sin alteraciones por los servidores de la Compañía. Al acceder a la
            plataforma de la Compañía y confirmar cualquier operación de
            transacción, los usuarios se obligan a responder con todo su
            patrimonio por las obligaciones derivadas. La Compañía no se hace
            responsable de los problemas causados por el mal uso de los métodos
            de autenticación elegidos por los usuarios, ni de los ataques
            cibernéticos, usurpación de identidad o cualquier otro ataque
            sufrido por los usuarios, y tampoco de los efectos de las acciones
            de terceros en la aplicación, Internet u otras plataformas de
            interconexión.
          </div>
          <div class="description">
            3. En caso de interrupción del servicio debido a fallas técnicas de
            la Compañía, se activará un plan de emergencia y se notificará a los
            usuarios a través de mensajes internos y SMS. La Compañía no se hace
            responsable de las pérdidas causadas por factores fuera de su
            control (por ejemplo, desastres naturales, ataques de terceros).
          </div>
          <div class="description">
            4. Cuando la Compañía detecte que la cuenta de un usuario puede
            haber sido accedida por un tercero no autorizado, y sin violar la
            Ley de Transparencia y Ordenamiento de los Servicios Financieros en
            lo referente a la prohibición de actividades discriminatorias,
            tendrá el derecho a restringir temporalmente el acceso a Lumi. En
            ese caso, la Compañía enviará una notificación al usuario a través
            de la App para que coopere en la verificación de la información y
            gestione los fondos de su cuenta.
          </div>
          <div class="description margin-b20">
            5. Si los usuarios detectan o sospechan riesgos de seguridad en su
            cuenta o en sus credenciales, o si un tercero ha accedido a su
            cuenta sin autorización, deben notificar inmediatamente a la
            Compañía y tomar las medidas necesarias según lo solicite la
            Compañía para recuperar el control de su cuenta. De lo contrario, la
            cuenta puede ser permanentemente inhabilitada.
          </div>

          <div class="paragraph">
            VIII. Responsabilidad de Zoriona, S.A. de C.V., SOFOM, E.N.R.
          </div>
          <div class="description">
            En caso de fallas o interrupciones del servicio causadas por la
            Compañía, ésta cuenta con un mecanismo de continuidad operativa. A
            través de la replicación en tiempo real de la base de datos en
            diferentes regiones, se garantiza la disponibilidad del servicio y
            la continuidad de las operaciones. Si ocurre alguna falla o la
            plataforma necesita mantenimiento, la Compañía notificará a los
            usuarios a través de correo electrónico. Además, excepto en caso de
            dolo probado por sentencia firme de un tribunal competente, la
            Compañía no se hace responsable de:
          </div>
          <div class="description">
            1. Fallas o funcionamiento deficiente del servicio causados por
            factores fuera del control de la Compañía, como fallas de sistema o
            línea, problemas en la red o suministro eléctrico, o fallas en los
            canales de comunicación.
          </div>
          <div class="description">
            2. Gastos, pérdidas o daños causados por la filtración de claves de
            seguridad o contenido de la App debido al mal uso o negligencia del
            usuario, siempre y cuando no haya sido reportado de acuerdo con los
            procedimientos establecidos.
          </div>
          <div class="description margin-b20">
            3. Gastos, pérdidas o daños directos o indirectos causados por virus
            informáticos o fallas del sistema en el smartphone utilizado por el
            usuario.
          </div>
          <div class="description margin-b20">
            A partir de la entrega de la información o la activación de la
            cuenta, los usuarios eximen a la Compañía de toda responsabilidad
            derivada de la operación con dicha información por parte del usuario
            o de terceros. Si un usuario incumple cualquiera de las obligaciones
            o condiciones establecidas en estos Términos, la Compañía tiene el
            derecho de cancelar inmediatamente el servicio correspondiente.
          </div>

          <div class="paragraph">
            IX. Modificación y Terminación de los Términos
          </div>
          <div class="paragraph">A. Actualización de los Términos</div>
          <div class="description">
            La Compañía tiene el derecho de modificar estos Términos de acuerdo
            con cambios legales o ajustes comerciales. Las modificaciones se
            notificarán a los usuarios a través de anuncios en el Sitio Web. El
            hecho de que los usuarios continúen utilizando los servicios se
            considerará como aceptación de los nuevos términos.
          </div>
          <div class="paragraph">B. Terminación de la Cuenta</div>
          <div class="description margin-b20">
            Si un usuario incumple gravemente estos Términos, la Compañía tiene
            el derecho de suspender o cancelar su cuenta y reservará el derecho
            de iniciar acciones legales.
          </div>
          <div class="paragraph">
            X. Declaración de Derechos de Propiedad Intelectual
          </div>
          <div class="description margin-b20">
            Los derechos de propiedad intelectual de Lumi y la tecnología y
            datos relacionados pertenecen a Zoriona. Queda prohibida la copia,
            modificación o uso comercial sin autorización previa. La Compañía
            tiene derecho a un uso no exclusivo de los contenidos generados por
            los usuarios durante el uso de la plataforma.
          </div>
          <div class="paragraph">
            XI. Aplicación de la Ley y Resolución de Diferencias
          </div>
          <div class="description margin-b20">
            Estos Términos están regidos por las leyes federales de México y las
            leyes locales de la Ciudad de México. En caso de controversias, las
            partes intentarán resolverlas por mediación. Si no se alcanza un
            acuerdo, se someterán a un juicio en los tribunales de la Ciudad de
            México.
          </div>
          <div class="description margin-b20">
            <span class="font-weight">Fecha de última actualización: </span>
            28 de abril de 2025
          </div>
          <div class="description margin-b20">
            <span class="font-weight">Dirección de la Compañía: </span>
            AVENIDA ROBLE 555 PISO 4, VALLE DEL CAMPESTRE, SAN PEDRO GARZA
            GARCIA, NUEVO LEON 66265 MEXICO
          </div>
          <div class="description">
            <span class="font-weight">Canales de Servicio al Cliente: </span>
          </div>
          <div class="tag">Teléfono: +52 5573628956</div>
          <div class="tag">Correo electrónico: servicio@zorionasofom.com</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Nosotros',
  components: {},
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {},
};
</script>

<style scoped>
.banner-bg {
  height: 474px;
  background: linear-gradient(180deg, #9bbce7 0%, #c5dbf7 42%, #eff6ff 100%);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: -1;
}
.banner {
  padding: 0 360px;
  margin-top: 70px;
}
.banner-box {
  height: 84px;
  background: linear-gradient(225deg, #fff8f2 0%, #ffe7d3 46%, #fff8f2 100%);
  border-radius: 34px 34px 0px 0px;
  padding: 28px 45px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  position: relative;
}
.img44 {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -75px;
}
.img44 img {
  width: 100%;
}
.print1 {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #1b67c8;
  position: absolute;
  left: 170px;
  top: 8px;
}
.print2 {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #1b67c8;
  position: absolute;
  left: 650px;
  top: 8px;
}
.print3 {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #1b67c8;
  position: absolute;
  left: 1040px;
  top: 8px;
}
.banner-box div {
  font-size: 16px;
  color: #977f6a;
  cursor: pointer;
  margin-bottom: 0 !important;
}
.muen1 {
  padding-left: 50px;
}
.muen2 {
  padding-left: 100px;
}
.muen3 {
  padding-right: 40px;
}
.tag {
  position: relative;
  padding: 0 20px;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 6px;
}
.tag::after {
  content: ' ';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(270deg, #287bdb 0%, #1156b9 100%);
  position: absolute;
  left: 0;
  top: 8px;
}

.content-box {
  padding: 0 360px;
  margin-bottom: 100px;
  margin-top: 70px;
}
.content {
  padding: 30px;
  background-color: white;
  position: relative;
  border-radius: 20px;
}
.img41 {
  position: absolute;
  width: 1090px;
  top: 50%;
  transform: translateY(-50%);
}

.description {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 6px;
  z-index: 99999;
}
.paragraph {
  font-weight: bold;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 6px;
  z-index: 9;
}
.margin-b8 {
  margin-bottom: 8px;
}
.margin-b20 {
  margin-bottom: 20px;
}
.font-weight {
  font-weight: bold;
  color: #000000 !important;
}
.c-table {
  border: 1px solid #979797;
  margin-bottom: 14px;
}
.row {
  height: 64px;
  border-bottom: 1px solid #979797;
  padding: 0 26px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.row span {
  display: flex;
  align-items: center;
}
.pagetitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 28px;
}
@media (max-width: 768px) {
  .pagetitle {
    font-size: 80px;
    margin-bottom: 42px;
    text-align: center;
  }
  .content-box {
    padding: 0 140px;
  }
  .paragraph {
    font-size: 65px;
    line-height: 110px;
    margin: 20px 0;
  }
  .img41 {
    width: 100%;
  }
  .description {
    font-size: 65px;
    line-height: 120px;
  }

  .banner {
    padding: 0 140px;
  }
  .banner-box {
    height: 384px;
    background: linear-gradient(225deg, #fff8f2 0%, #ffe7d3 46%, #fff8f2 100%);
    border-radius: 34px 34px 0px 0px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .banner-box div {
    font-size: 65px;
    color: #977f6a;
    cursor: pointer;
    margin-right: 0;
    flex: 1;
    text-align: center;
  }
  .tag {
    font-size: 65px;
    line-height: 120px;
    margin-right: 0;
    padding-left: 60px;
  }
  .tag::after {
    content: ' ';
    width: 25px;
    height: 25px;
    top: 50px;
    left: 0;
  }
  .img32 {
    display: none;
  }
}
</style>
